import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { handleForgotPassword, handleConfirmForgotPassword } from '../auth/AuthHelper';

const validatePassword = password => {
    const errors = [];
    if (password.length < 8) errors.push('Password must be at least 8 characters');
    if (!/\d/.test(password)) errors.push('Password must contain at least 1 number');
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) errors.push('Password must contain at least 1 special character');
    if (!/[A-Z]/.test(password)) errors.push('Password must contain at least 1 uppercase letter');
    if (!/[a-z]/.test(password)) errors.push('Password must contain at least 1 lowercase letter');
    return errors;
};

const ForgotPasswordPage = () => {
    const [step, setStep] = useState(1);
    const [username, setUsername] = useState('');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleRequestCode = async e => {
        e.preventDefault();
        setLoading(true);
        try {
            await handleForgotPassword(username);
            toast.success('Check your email for a confirmation code');
            setStep(2);
        } catch (error) {
            toast.error('Failed: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleResetPassword = async e => {
        e.preventDefault();
        const passwordErrors = validatePassword(newPassword);
        if (passwordErrors.length > 0) {
            passwordErrors.forEach(err => toast.error(err));
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }
        setLoading(true);
        try {
            await handleConfirmForgotPassword(username, code, newPassword);
            toast.success('Password reset successful');
            navigate('/login');
        } catch (error) {
            toast.error('Failed: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2>Forgot Password</h2>
            {step === 1 ? (
                <form onSubmit={handleRequestCode}>
                    <label>
                        Username:
                        <input
                            type="text"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            required
                        />
                    </label>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Sending...' : 'Send Reset Code'}
                    </button>
                    <p>
                        <Link to="/login">Back to login</Link>
                    </p>
                </form>
            ) : (
                <form onSubmit={handleResetPassword}>
                    <p>A confirmation code was sent to the email on your account.</p>
                    <label>
                        Confirmation Code:
                        <input
                            type="text"
                            value={code}
                            onChange={e => setCode(e.target.value)}
                            required
                            autoComplete="one-time-code"
                        />
                    </label>
                    <label>
                        New Password:
                        <input
                            type="password"
                            value={newPassword}
                            onChange={e => setNewPassword(e.target.value)}
                            required
                        />
                    </label>
                    <label>
                        Confirm New Password:
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            required
                        />
                    </label>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Resetting...' : 'Reset Password'}
                    </button>
                    <button type="button" onClick={() => setStep(1)} disabled={loading}>
                        Back
                    </button>
                    <h3>Password requirements</h3>
                    <ul>
                        <li>Minimum 8 characters</li>
                        <li>At least 1 number</li>
                        <li>At least 1 special character</li>
                        <li>At least 1 uppercase letter</li>
                        <li>At least 1 lowercase letter</li>
                    </ul>
                </form>
            )}
        </div>
    );
};

export default ForgotPasswordPage;
